import { createPinia, setActivePinia } from 'pinia';

// Хранилище состояния. Pinia, а не свой объект на reactive():
//
// свой был ровно тем же по форме, но без единого правила, куда что класть, —
// и состояние расползалось по компонентам. Счётчик повторов жил и в шапке
// проекта, и во вкладке карточек: ответ менял цифру в одном месте, а в другом
// оставалось старое число до перезагрузки. Библиотека сама по себе этого не
// чинит, зато даёт общее место и общий словарь: стор объявлен через
// defineStore, состояние в state, изменения в actions — и «а положу-ка я это
// в компонент» перестаёт быть вариантом по умолчанию.
//
// Активируем сразу при импорте: за состоянием ходят не только компоненты, но и
// обычные модули — маршрутизатор, загрузка справочников, обёртка над API.
// Без setActivePinia стор из такого модуля не создать.
export const pinia = createPinia();
setActivePinia(pinia);
